// extracted by mini-css-extract-plugin
export default {"container":"CategorySection_container__Z0PrV","card":"CategorySection_card__YNA-v"};